const facebookStartWithHTTPS = new RegExp(/^https:\/\/www\.facebook\.com\/\S+$/)

export { facebookStartWithHTTPS }
